import * as React from "react";
import {Switch} from "react-router-dom";
import ReloadableRoute from "components/ReloadableRoute/ReloadableRoute";
import {reefsRouteLinks} from "areas/reefs/reefsRouteLinks";
import {InternalRedirect} from "components/Navigation/InternalRedirect";
import CreateReef from "areas/reefs/CreateReef";
import {Reefs} from "areas/reefs/Reefs";
import ReefLayout from "areas/reefs/ReefLayout";
import HostedScriptsRollout from "areas/reefs/HostedScriptsRollout";

const ConfigurationLayout: React.FunctionComponent<{}> = _ =>
    <Switch>
        <ReloadableRoute path={reefsRouteLinks.create} exact={true} component={CreateReef}/>
        {/* Must precede the reef(":id") route, which would otherwise match it as a reef id. */}
        <ReloadableRoute path={reefsRouteLinks.hostedScriptsRollout} exact={true} component={HostedScriptsRollout}/>
        <ReloadableRoute path={reefsRouteLinks.root} exact={true} component={Reefs}/>
        <ReloadableRoute path={reefsRouteLinks.reef(":id").root} component={ReefLayout}/>
        <ReloadableRoute render={() => <InternalRedirect to={reefsRouteLinks.root}/>}/>
    </Switch>;

export default ConfigurationLayout;
